export default __webpack_public_path__ + "static/media/2.556b2e9e.png";